export const onlyDigits = (v: string) => v.replace(/[^0-9]/gi, "");

export const onlyLetters = (v: string) => v.replace(/[^A-Za-z]/gi, "");

export const insertSpacesBetweenWords = (v: string) => {
  return v
    .replace(/([a-z])([A-Z])/g, "$1 $2")
    .replace(/([A-Z]+)([A-Z][a-z])/g, "$1 $2")
    .trim();
};

export const multipleBlanksFilter = (v: string) =>
  v.replace(/^ +/, "").replace(/ {2,}/g, " ");
